import {useCallback, useEffect, useMemo, useState} from 'react';
import {breakPoint, shownNumber, slideContainerWidth} from './const';

export const useSlide = (length: number) => {
  const [currentSlidePage, setCurrentSlidePage] = useState<number>(1);

  const total = useMemo(() => Math.ceil(length / shownNumber), [length]);

  const slidePositionX = useMemo(
    () => slideContainerWidth * (currentSlidePage - 1),
    [currentSlidePage],
  );

  const back = useCallback(() => {
    if (currentSlidePage === 1) return;

    setCurrentSlidePage((previous) => {
      const newPage = previous - 1;
      if (newPage < 0) return previous;

      return newPage;
    });
  }, [currentSlidePage]);

  const forward = useCallback(() => {
    if (currentSlidePage === total) return;

    setCurrentSlidePage((previous) => {
      const newPage = previous + 1;
      if (newPage > total) return previous;

      return newPage;
    });
  }, [currentSlidePage, total]);

  const slideOnClickDot = useCallback(
    (index: number) => {
      if (index > total) return;

      setCurrentSlidePage(index);
    },
    [total],
  );

  const handleResize = () => {
    const isPc = globalThis.matchMedia(`(min-width: ${breakPoint})`).matches;

    if (isPc) {
      // SPモードからPCモードに切り替わった場合、スライダーの位置を先頭に戻す
      setCurrentSlidePage(1);
    }
  };

  // PCモードのみ、ユーザーによるスクロール操作を無効にする
  useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    currentSlidePage,
    total,
    slidePositionX,
    back,
    forward,
    slideOnClickDot,
  };
};
